export enum LimitEnum {
  noLimit,
  limit,
}

export const LimitMap = new Map([
  [LimitEnum.noLimit, '限额关闭'],
  [LimitEnum.limit, '限额开启'],
]);
